import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  private screenSizeSubject = new BehaviorSubject<string>('default');

  screenSize = this.screenSizeSubject.asObservable();

  // Define custom breakpoints to match Tailwind's breakpoints
  private customBreakpoints = {
    sm: '(min-width: 600px)',
    md: '(min-width: 960px)',
    lg: '(min-width: 1280px)',
    xl: '(min-width: 1440px)',
  };

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([
        this.customBreakpoints.sm,
        this.customBreakpoints.md,
        this.customBreakpoints.lg,
        this.customBreakpoints.xl,
      ])
      .subscribe((result) => {
        if (result.breakpoints[this.customBreakpoints.xl]) {
          this.screenSizeSubject.next('xl');
        } else if (result.breakpoints[this.customBreakpoints.lg]) {
          this.screenSizeSubject.next('lg');
        } else if (result.breakpoints[this.customBreakpoints.md]) {
          this.screenSizeSubject.next('md');
        } else if (result.breakpoints[this.customBreakpoints.sm]) {
          this.screenSizeSubject.next('sm');
        } else {
          this.screenSizeSubject.next('default');
          // Fallback for smaller than 'sm'
        }
      });
  }
}
